// Module-level token acquisition. Used by both the useAuth hook (inside
// React context) and the api() fetch wrapper (anywhere). On
// InteractionRequiredAuthError MSAL's acquireTokenRedirect navigates the
// browser; the caller's promise rejects so callers don't accidentally use
// a stale token while the redirect is in flight.
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "./AuthProvider";
import { loginRequest } from "./msalConfig";

export async function getAccessToken(): Promise<string> {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("No signed-in account");
  try {
    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return result.accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(loginRequest);
    }
    throw e;
  }
}
